import { MONTHS } from '../constants/months';

export const HIDDEN_REASONS = {
    ECO: 'ECO hidden (turn on ECO)',
    VENDOR: 'Vendor not active',
    PARTNER: 'Partner not active',
    SHOWROOM: 'Showroom not in budget',
    CATEGORY: 'Category not in budget',
    UNMATCHED: 'Not matched',
};

const toKey = (value) => String(value ?? '').trim().toUpperCase();

export const findHiddenBudgetLines = ({ leftovers, territories, data, factoryVendors, showrooms, companyMasterMap, isEcoEnabled }) => {
    const territoryNames = {};
    (territories || []).forEach(t => {
        territoryNames[String(t.id)] = t.displayName || t.name || `Territory ${t.id}`;
    });

    const loadedPartners = new Set();
    const loadedShowrooms = new Set();
    const loadedCategoryPaths = new Set();
    (data || []).forEach(row => {
        if (row.type === 'PARTNER') loadedPartners.add(toKey(row.companyId));
        if (row.type === 'SHOWROOM') loadedShowrooms.add(toKey(row.showroomId));
        if (row.type === 'PRODUCT') {
            loadedShowrooms.add(toKey(row.showroomId));
            loadedCategoryPaths.add(`${toKey(row.companyId)}|${toKey(row.showroomId)}|${toKey(row.categoryId)}`);
        }
    });

    const vendorNames = {};
    (factoryVendors || []).forEach(v => { vendorNames[toKey(v.id)] = v.name; });

    const showroomNames = {};
    (showrooms || []).forEach(s => { showroomNames[toKey(s.id)] = s.name || s.shortKey || ''; });

    const lines = [];
    Object.values(leftovers || {}).forEach(entry => {
        const meta = entry.__meta;
        if (!meta) return;

        const territoryId = String(meta.territoryId);
        if (!territoryNames[territoryId]) return;

        const total = MONTHS.reduce((sum, m) => sum + (Number(entry[m]) || 0), 0);
        if (Math.abs(total) < 0.5) return;

        const partner = toKey(meta.customerNum);
        const hasShowroom = meta.showroomNum !== null && meta.showroomNum !== undefined && meta.showroomNum !== '';
        const showroom = hasShowroom ? toKey(meta.showroomNum) : partner;
        const product = toKey(meta.productNum);
        const category = toKey(meta.category);
        const vendorName = vendorNames[product];

        let reason = HIDDEN_REASONS.UNMATCHED;
        if (vendorName && vendorName.toUpperCase().includes('NOLTE ECO') && !isEcoEnabled) reason = HIDDEN_REASONS.ECO;
        else if (!vendorName) reason = HIDDEN_REASONS.VENDOR;
        else if (!loadedPartners.has(partner)) reason = HIDDEN_REASONS.PARTNER;
        else if (showroom !== partner && !loadedShowrooms.has(showroom)) reason = HIDDEN_REASONS.SHOWROOM;
        else if (!loadedCategoryPaths.has(`${partner}|${showroom}|${category}`)) reason = HIDDEN_REASONS.CATEGORY;

        lines.push({
            territoryId,
            territoryName: territoryNames[territoryId],
            partner,
            partnerName: companyMasterMap?.[partner]?.name || '',
            showroom,
            showroomName: showroomNames[showroom] || '',
            category,
            product,
            productName: vendorName || product,
            total,
            reason,
        });
    });

    return lines.sort((a, b) => b.total - a.total);
};
